import { reactive } from 'vue'

/**
 * Panneau d'aide (HelpDrawer) : ouvert depuis le bouton « Aide » du menu ou de l'en-tête,
 * éventuellement directement sur un guide.
 */
export const helpState = reactive({
    open: false,
    guideId: null,
})

export function openHelp(guideId = null) {
    helpState.guideId = guideId
    helpState.open = true
}

export function closeHelp() {
    helpState.open = false
}

export function toggleHelp() {
    if (helpState.open) {
        closeHelp()
    } else {
        openHelp()
    }
}
